function mountAgencyGTMContainer () {
  const gtmId = this.getAgencyGTMId();
  this.win.dataLayer = this.win.dataLayer || [];
  this.win.dataLayer.push({'gtm.start': new Date().getTime(),event:'gtm.js'});
  const f = this.doc.getElementsByTagName('script')[0];
  const j = this.doc.createElement('script');
  j.async = true;
  j.src = '//www.googletagmanager.com/gtm.js?id=' + gtmId;
  f.parentNode.insertBefore(j,f);
};

function fireGTMPageView(eventName) {
  this.mountAgencyGTMContainer()
  this.win.dataLayer = this.win.dataLayer || [];
  this.win.dataLayer.push({
      'event': eventName || 'PageView'
  });
}

function fireGTMConversion(eventName) {
  this.win.dataLayer = this.win.dataLayer || [];
  this.win.dataLayer.push({
      'event': eventName || 'AdClick'
  });
}

function getAgencyGTMId(){
  const agAgencyGtmId = this.getOcodeValue('component.AgencyGtm.agencyGtmId');
  const pppAgencyGtmId = this.getOcodeValue('component.PartialPageViewPixel.agencyGtmId');
  return agAgencyGtmId || pppAgencyGtmId;
}

module.exports = {
  mountAgencyGTMContainer,
  fireGTMPageView,
  fireGTMConversion,
  getAgencyGTMId,
};
